/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { ModalBodyButtonsProps } from 'types/components/Modal';
import { SelectOptions } from '../index';

export default function ModalBodyButtons({ bodyButtons }: ModalBodyButtonsProps): JSX.Element | null {
  return bodyButtons ? <SelectOptions options={bodyButtons} /> : null;
}
